import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
const requestService = new RequestService()
var snakeCaseKeys = require('snakecase-keys')

export class MainRequests {
  save (body) {
    const route = ServerDirections.CREATE_BOOKING
    const method = 'post'
    function map (data) {
      return data
    }
    return requestService.makePromise(route, method, { body: snakeCaseKeys(body) }, map)
  }
}
